{
  "schemaVersion": 1,
  "slug": "vercel",
  "name": "Vercel",
  "description": "Inspect projects, deployments, and runtime logs.",
  "categories": [
    "developer"
  ],
  "featured": false,
  "branding": {
    "logoUrl": "/brands/apps/vercel.svg",
    "darkLogoUrl": "/brands/apps/vercel-dark.svg"
  },
  "urlPatterns": [
    "https://mcp.vercel.com/*"
  ],
  "methods": [
    {
      "key": "mcp-oauth",
      "transport": "mcp_remote",
      "auth": "oauth",
      "ownershipModes": [
        "customer",
        "dcr"
      ],
      "whenToUse": "Use the provider-hosted connection for the quickest setup.",
      "defaults": {
        "serverUrl": "https://mcp.vercel.com/mcp"
      },
      "guidanceMd": "Connect the Vercel team and projects agents should operate.",
      "riskTier": "S3",
      "requiredResourceFilters": [
        "team",
        "project",
        "environment"
      ]
    }
  ],
  "availability": {
    "available": false,
    "reason": "Vercel currently reviews and approves MCP clients."
  }
}
